import { render, staticRenderFns } from "./Hotline.vue?vue&type=template&id=65b0d236&scoped=true&"
import script from "./Hotline.vue?vue&type=script&lang=ts&"
export * from "./Hotline.vue?vue&type=script&lang=ts&"
import style0 from "./Hotline.vue?vue&type=style&index=0&id=65b0d236&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b0d236",
  null
  
)

export default component.exports